import { defineMessages } from 'react-intl'

export * from './messages/cantons'

export const commonDescriptors = defineMessages({
  yea: {
    id: 'common.yea',
    defaultMessage: 'Ja',
  },
  nay: {
    id: 'common.nay',
    defaultMessage: 'Nein',
  },
  noInformation: {
    id: 'common.noInformation',
    defaultMessage: 'k.A.',
  },
  noResult: {
    id: 'common.noResult',
    defaultMessage: 'Kein Resultat',
  },
  voterTurnout: {
    id: 'common.voterTurnout',
    defaultMessage: 'Beteiligung {percent, number, percent1}',
  },
  majorityOfCantonsRequired: {
    id: 'common.majorityOfCantonsRequired',
    defaultMessage: 'Ständemehr erforderlich',
  },
  majorityOfCantonsReached: {
    id: 'common.majorityOfCantonsReached',
    defaultMessage: 'Ständemehr erreicht',
  },
  majorityOfCantonsNotReached: {
    id: 'common.majorityOfCantonsNotReached',
    defaultMessage: 'Ständemehr nicht erreicht',
  },
  allResults: {
    id: 'common.allResults',
    defaultMessage: 'Alle Resultate',
  },
  moreResults: {
    id: 'common.moreResults',
    defaultMessage: 'Weitere Abstimmungsresultate',
  },
  inProgressStatus: {
    id: 'common.inProgressStatus',
    defaultMessage: 'Noch kein Resultat',
  },
  trendStatus: {
    id: 'common.trendStatus',
    defaultMessage: 'Trend {at}',
  },
  projection: {
    id: 'common.projection',
    defaultMessage: 'Liveprognose',
  },
  interimResult: {
    id: 'common.interimResult',
    defaultMessage: 'Zwischenresultat',
  },
  projectionStatus: {
    id: 'common.projectionStatus',
    defaultMessage: 'Liveprognose {at}',
  },
  projectionYea: {
    id: 'common.projectionYea',
    defaultMessage: '{projection, number, percent1} Ja',
  },
  projectionNay: {
    id: 'common.projectionNay',
    defaultMessage: '{projection, number, percent1} Nein',
  },
  finalResult: {
    id: 'common.finalResult',
    defaultMessage: 'Schlussresultat',
  },
  finalResultYea: {
    id: 'common.finalResultYea',
    defaultMessage: '{finalResult, number, percent1} Ja',
  },
  finalResultNay: {
    id: 'common.finalResultNay',
    defaultMessage: '{finalResult, number, percent1} Nein',
  },
  back: {
    id: 'common.back',
    defaultMessage: 'Abstimmungen',
  },
  noData: {
    id: 'QE91UB6',
    description: 'Abbreviated label if component has no data (n.a.)',
    defaultMessage: 'k.A.',
  },
  chTitle: {
    id: '6eMmiLG',
    defaultMessage: 'Schweiz',
  },
  voterShare: {
    id: 'w6FD8cG',
    defaultMessage: 'Wähleranteil',
  },
  voterSharePercent: {
    id: 'kE9Mbgr',
    defaultMessage: 'Wähleranteil in %',
  },
  trendUp2: {
    id: '1YuviKV',
    defaultMessage: 'Grosse Gewinne wahrscheinlich',
  },
  trendUp1: {
    id: '9tTAWJT',
    defaultMessage: 'Gewinne wahrscheinlich',
  },
  trend0: {
    id: 'norNLNj',
    defaultMessage: 'Stimmanteil bleibt stabil',
  },
  trendDown1: {
    id: 'EWi4MH6',
    defaultMessage: 'Verluste wahrscheinlich',
  },
  trendDown2: {
    id: 'ihGDFq4',
    defaultMessage: 'Grosse Verluste wahrscheinlich',
  },
  incumbent: {
    id: 'EoN28fy',
    description: 'Added after the candidate name if he/she is incumbent',
    defaultMessage: 'bisher',
  },
  tieBreakBlank: {
    id: 'z9qfREw',
    defaultMessage: '–',
    description: 'Intentionally empty',
  },
  projectionInitiative: {
    id: 'ojJKG2j',
    defaultMessage: '{projection, number, percent1}',
  },
  projectionCounterproposal: {
    id: 'o6KyHDJ',
    defaultMessage: '{projection, number, percent1}',
  },
  finalResultInitiative: {
    id: 'jfUYdS4',
    defaultMessage: '{finalResult, number, percent1}',
  },
  finalResultCounterproposal: {
    id: 'k23CUzg',
    defaultMessage: '{finalResult, number, percent1}',
  },
  tiebreakLabel: {
    id: '81TzMfG',
    defaultMessage: `{outcome, select, yea { Initia\u00ADtive } nay { Gegen\u00ADvorschlag } other {WAT} }`,
  },
  finalResultState: {
    id: 'CGXRBqj',
    defaultMessage: `{outcome, select, yea {Angenommen} nay {Abgelehnt} other {WAT} }`,
  },
  municipalities: {
    id: 'Jcmfaqc',
    defaultMessage: `Gemeinden`,
  },
  listView: {
    id: 'common.listView',
    defaultMessage: 'Listenansicht',
  },
  mapView: {
    id: 'common.mapView',
    defaultMessage: 'Kartenansicht',
  },
})
